import { SS_TOKEN } from "../../presentation/resources/secureStorageManager";
import secureStorage from "../../utility/secureStorage";

export const ApiGetServiceWrapper = ({ url = "", headers = {} }) => {
  let token = secureStorage.getItem(SS_TOKEN);
  return new Promise(async (resolve, reject) => {
    return fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "X-Frame-Options": "DENY",
        ...headers,
      },
    })
      .then((response) => response.json())
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};
export const ApiGetServiceWrapperBlob = ({ url = "", headers = {} }) => {
  let token = secureStorage.getItem(SS_TOKEN);
  return new Promise(async (resolve, reject) => {
    return fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "X-Frame-Options": "DENY",
        ...headers,
      },
    })
      .then((response) => response.blob())
      .then((response) => {
        resolve(response);
      })
      .catch((error) => reject(error));
  });
};

export const ApiPostServiceWrapper = ({
  url = "",
  headers = {},
  body = {},
}) => {
  let token = secureStorage.getItem(SS_TOKEN);
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "X-Frame-Options": "DENY",
        ...headers,
      },
      body: JSON.stringify({
        ...body,
      }),
    })
      .then((res) => res.json())
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const ApiPutServiceWrapper = ({ url = "", headers = {}, body = {} }) => {
  let token = secureStorage.getItem(SS_TOKEN);
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "PUT",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "X-Frame-Options": "DENY",
        ...headers,
      },
      body: JSON.stringify({
        ...body,
      }),
    })
      .then((res) => res.json())
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const ApiGetServiceWithoutAuthenticationWrapper = ({
  url = "",
  headers = {},
  blob = false,
}) => {
  return new Promise(async (resolve, reject) => {
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Frame-Options": "DENY",
        ...headers,
      },
    })
      .then((response) => response.json())
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
};

export const ApiPostServiceWithoutAuthenticationWrapper = ({
  url = "",
  headers = {},
  body = {},
}) => {
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Frame-Options": "DENY",
        ...headers,
      },
      body: JSON.stringify({
        ...body,
      }),
    })
      .then((res) => res.json())
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};

export const ApiDeleteServiceWrapper = ({
  url = "",
  headers = {},
  body = {},
}) => {
  let token = secureStorage.getItem(SS_TOKEN);
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        "X-Frame-Options": "DENY",
        ...headers,
      },
      body: JSON.stringify({
        ...body,
      }),
    })
      .then((res) => res.json())
      .then((response) => resolve(response))
      .catch((err) => reject(err));
  });
};
